<template>
  <div class="sign-up__confirm">
    <figure class="sign-up__confirm__figure">
      <img
        src="/images/registration/mail–illustration.svg"
        alt="Precisamos que você confirme seu e-mail"
      />
    </figure>

    <h2 class="sign-up__confirm__title">
      Quase lá! <br class="mobile-only" />
      Confirme seu e-mail.
    </h2>

    <p class="sign-up__confirm__description">
      Clique no link de confirmação que enviamos para o e-mail
      <span class="text-bold">{{ mail }}</span> para concluir o
      cadastro.
    </p>

    <p class="sign-up__confirm__warning">
      Não recebeu o e-mail? Não esqueça de conferir sua caixa de Spam! Se não
      estiver lá,
      <button class="sign-up__confirm__action" @click="sendEmail(true)">
        clique aqui
      </button>
      para reenviar.
    </p>

    <p class="sign-up__confirm__warning">
      Cadastrou o e-mail errado? <br />
      <button class="sign-up__confirm__action" @click.prevent="toggleModal">
        Clique aqui
      </button>
      para alterar.
    </p>

    <transition name="fade">
      <modal-base
        title="Alterar endereço de e-mail"
        v-show="isModalVisible"
        @close-modal="toggleModal"
      >
        <template v-slot:content>
          <div>
            <fieldset
              class="formLine"
              :class="{
                active: replaceEmail,
                error: $v.replaceEmail.$error,
                focus: focus.replaceEmail,
              }"
            >
              <div class="inputBox">
                <label for="replace-email">Novo e-mail*</label>
                <input
                  type="email"
                  id="replace-email"
                  v-model="replaceEmail"
                  @focus="iptFocus('replaceEmail', $event)"
                  @blur="iptBlur('replaceEmail', $event)"
                />
                <p class="errorText">{{ errors.replaceEmail }}</p>
              </div>
            </fieldset>

            <fieldset
              class="formLine"
              :class="{
                active: replaceEmailConfirm,
                error: $v.replaceEmailConfirm.$error,
                focus: focus.replaceEmailConfirm,
              }"
            >
              <div class="inputBox">
                <label for="replace-email-confirm">Confirme seu e-mail*</label>
                <input
                  type="email"
                  id="replace-email-confirm"
                  v-model="replaceEmailConfirm"
                  @focus="iptFocus('replaceEmailConfirm', $event)"
                  @blur="iptBlur('replaceEmailConfirm', $event)"
                />
              </div>
            </fieldset>
          </div>
        </template>

        <template v-slot:footer>
          <div>
            <button class="modal__footer__button" @click.prevent="toggleModal">
              Voltar
            </button>
            <button
              class="modal__footer__button modal__footer__button--action"
              @click="changeEmail"
            >
              Alterar
            </button>
          </div>
        </template>
      </modal-base>
    </transition>

    <transition name="fade">
      <div class="modal modal--resend" v-if="resend">
        <div class="modal__header">
          <p>confirmação de email</p>

          <a href="javascript:;" class="closeModal">
            <svg class="ico" @click="toggleResendModal(false)">
              <use xlink:href="/images/svg-symbols.svg#close" />
            </svg>
          </a>
        </div>
        <div class="modal__content">
          <p>O email de confirmação foi reenviado!</p>
        </div>
        <div class="modal__footer">
          <button
            name="Confirmação de email"
            type="button"
            class="btnBorder btnBorder--small"
            @click="toggleResendModal(false)"
          >
            <span>OK</span>
          </button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="modal modal--blocked" v-if="blocked">
        <div class="modal__header">
          <p>confirmação de email</p>

          <a href="javascript:;" class="closeModal">
            <svg class="ico" @click="toggleBlockedModal(false)">
              <use xlink:href="/images/svg-symbols.svg#close" />
            </svg>
          </a>
        </div>
        <div class="modal__content">
          <p>
            Você atingiu o limite de tentativas, favor entrar em contato com
            nosso suporte!
          </p>
        </div>
        <div class="modal__footer">
          <a :href="supportPublicDashUrl" class="btnBorder btnBorder--small">
            <span>suporte</span>
          </a>
        </div>
      </div>
    </transition>

    <toast ref="toast" :message="message" :time="3000" />
  </div>
</template>

<script>
import { required, email, isUnique, sameAs } from "vuelidate/lib/validators";
import ModalBase from "commons/js/components/atoms/ModalBase.vue";
import Toast from 'commons/js/components/atoms/Toast.vue';

import {scrollToTop} from 'commons/js/utils/scroll.js';

export default {
  data() {
    return {
      resend: false,
      blocked: false,
      showReplaceInput: false,
      replaceEmail: "",
      replaceEmailConfirm: "",
      replaceEmailCatchError: false,
      isModalVisible: false,

      timerActive: false,

      message: '',

      timer: null,

      errorMessages: {
        isEmpty: "Campo obrigatório! Não esqueça de preenchê-lo.",
        isInvalid: "Endereço de e-mail inválido! Verifique sua resposta.",
        isNotUnique: "Este endereço de e-mail já está cadastrado ou é inválido. Gostaria de fazer login?",
      },

      errors: {
        replaceEmail: "",
      },

      focus: {
        replaceEmail: false,
      },
      supportPublicDashUrl: ''
    };
  },

  mounted() {
    scrollToTop();
    this.supportPublicDashUrl = MEConfig.get('dash.url') + '/suporte';
  },

  computed: {
    mail() {
      let email = this.$attrs.me.email
      ? this.$attrs.me.email
      : localStorage.getItem('user-mail');

      return email;
    }
  },

  components: {
    ModalBase,
    Toast
  },

  created() {
    this.sendEmail();
  },

  methods: {
    sendEmail(resend = false) {

      if (this.timerActive) {
        this.message = 'Aguarde para tentar novamente.';
        this.$refs.toast.show();

        return;
      }

      if (resend && !this.timerActive) {
        this.initTimer();
      }

      this.$parent.loading = true;
      axios
        .get(
          "/api/v2/me/send/confirmation-mail" + (resend ? "?resend=true" : "")
        )
        .then(() => {
          if (resend) {
            this.toggleResendModal(true);
          }
        })
        .catch((error) => {
          if (resend) {
            if (error.response.status === 403) {
              this.toggleBlockedModal(true);
            }
          }
        })
        .finally(() => {
          this.$parent.loading = false;
        });
    },

    isValidEmail(email) {
      const mailFormat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !!email.match(mailFormat);
    },

    async isUniqueEmail() {
      const { data } = await axios.get("/api/v2/me");
      return data.email !== this.replaceEmail;
    },

    async changeEmail() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      if (this.timerActive) {
        this.message = 'Aguarde para tentar novamente.';
        this.$refs.toast.show();

        return;
      }

      if (!this.timerActive) {
        this.initTimer();
      }

      this.$parent.loading = true;

      if (this.replaceEmail === "") {
        this.errors.replaceEmail = this.errorMessages.isEmpty;
        this.$parent.loading = false;
        return;
      }

      if (!this.isValidEmail(this.replaceEmail)) {
        this.errors.replaceEmail = this.errorMessages.isInvalid;
        this.$parent.loading = false;
        return;
      }

      const isUnique = await this.isUniqueEmail();

      if (!isUnique) {
        this.errors.replaceEmail = this.errorMessages.isNotUnique;
        this.$parent.loading = false;
        return;
      }

      await axios
        .put("/api/v2/me", {
          email: this.replaceEmail,
        })
        .then((res) => {
          this.showReplaceInput = false;
          localStorage.setItem('user-mail', this.mail);
          this.$parent.loadMe();
          this.finishTimer();
          this.isModalVisible = false;
          this.sendEmail(true);
        })
        .catch(({ response }) => {
          this.showReplaceInput = true;
          if (response && response.data && response.data.error) {
            this.replaceEmailCatchError = true;
            this.showReplaceInput = true;
          }
        })
        .finally(() => {
          this.$parent.loading = false;
        });
    },

    toggleResendModal(visible) {
      this.resend = visible;
      this.$parent.showModal = visible;
    },

    toggleBlockedModal(visible) {
      this.blocked = visible;
      this.$parent.showModal = visible;
    },

    hideAllModals() {
      this.resend = false;
      this.blocked = false;
    },

    iptFocus(ipt) {
      this.focus[ipt] = true;
    },

    iptBlur(ipt) {
      this.focus[ipt] = false;
      this.$v[ipt].$touch();
      this.updateErrorMessage(ipt);
    },

    updateErrorMessage(key) {
      let errorTypes = Object.keys(this.errorMessages);
      for (let i = 0; i < errorTypes.length; i++) {
        let errorType = errorTypes[i];
        if (
          this.$v[key].hasOwnProperty(errorType) &&
          !this.$v[key][errorType]
        ) {
          this.errors[key] = "";
          if (this.errorMessages.hasOwnProperty(errorType)) {
            this.errors[key] = String(this.errorMessages[errorType]).replace(
              /__field__/,
              String(key)
                .replace(/^ipt/, "")
                .replace(/Change$/, "")
            );
          }
          break;
        }
      }
    },

    initTimer() {
      let time = 30000;

      this.timerActive = true;

      this.timer = window.setTimeout(() => this.finishTimer(), time);
    },

    finishTimer() {
      this.timerActive = false;
      window.clearInterval(this.timer);
    },

    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
    },
  },

  validations: {
    replaceEmail: {
      required,
      email,
      isUnique(value) {
        if (this.replaceEmailCatchError) {
          value = false;
          this.errors.replaceEmail = this.errorMessages.isNotUnique;
        }
        return value;
      },
    },

    replaceEmailConfirm: {
      required,
      sameAsReplaceEmail: sameAs("replaceEmail"),
    },
  }
};
</script>

<style lang="stylus" scoped>
.btnBlue:hover {
  color: white;
}
</style>
